import { render, staticRenderFns } from "./PreviewCredential.vue?vue&type=template&id=54e7674b&scoped=true&"
import script from "./PreviewCredential.vue?vue&type=script&lang=js&"
export * from "./PreviewCredential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e7674b",
  null
  
)

export default component.exports